import IcStickyNote from './IcStickyNote'
export default IcStickyNote
